// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n    /* Undo Bootstrap's setting to turn off even/odd coloring of table rows in print mode */\n.table td[data-v-26235fac] {\n        background-color: transparent !important;\n}\n.table-striped>tbody>tr[data-v-26235fac]:nth-of-type(odd) {\n        background-color: #f9f9f9 !important\n}\n}", ""]);
// Exports
module.exports = exports;
